import React, { useState, useEffect, useCallback } from 'react';
import { useTransition, animated, useSpringRef } from '@react-spring/web'

import useAuth from '~/hooks/useAuth';

import dabangBridge from '~/utils/bridge';
import apiCall, { TEST_URL, LIVE_URL } from '~/utils/apiCall';

import BG from '~/components/background';

import top from './images/top.png';
import mid from './images/mid.png';
import bottom from './images/bottom.png';

import day00 from './images/day00.png';
import day01 from './images/day01.png';
import day02 from './images/day02.png';
import day03 from './images/day03.png';
import day04 from './images/day04.png';
import day05 from './images/day05.png';
import day06 from './images/day06.png';
import day07 from './images/day07.png';
import day08 from './images/day08.png';
import day09 from './images/day09.png';
import day10 from './images/day10.png';
import day11 from './images/day11.png';
import day12 from './images/day12.png';
import day13 from './images/day13.png';
import day14 from './images/day14.png';
import day15 from './images/day15.png';
import day16 from './images/day16.png';
import day17 from './images/day17.png';
import day18 from './images/day18.png';
import day19 from './images/day19.png';
import day20 from './images/day20.png';
import day21 from './images/day21.png';
import stamp from './images/stamp.png';

import { Wrap, AgreeWrap, LabelWrap, Label, Checkbox, Ul, RelativeWrap } from './styled'; 

function Arrow() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path fill="#051628" d="M0 0H40V40H0z" transform="translate(-391.000000, -2172.000000) translate(0.000000, 2172.000000) translate(391.000000, 0.000000)"/>
              <path stroke="#FFF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M27 9L27 23 13 23" transform="translate(-391.000000, -2172.000000) translate(0.000000, 2172.000000) translate(391.000000, 0.000000) translate(20.000000, 16.000000) rotate(-315.000000) translate(-20.000000, -16.000000)"/>
          </g>
          </g>
        </g>
      </g>
  </svg>
  );
}

const CHECK_IMG = [
  day00,
  day01,
  day02,
  day03,
  day04,
  day05,
  day06,
  day07,
  day08,
  day09,
  day10,
  day11,
  day12,
  day13,
  day14,
  day15,
  day16,
  day17,
  day18,
  day19,
  day20,
  day21,
];

function MainComponent() {
  const [showImg, setShowImg] = useState(false);
  const [isSending, setSending] = useState(false);
  const [idx, setIdx] = useState(0);
  const [agree, setAgree] = useState(false);

  const transRef = useSpringRef()
  const transitions = useTransition(idx, {
    ref: transRef,
    key: idx,
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 500 },
  });

  const transitionsStamp = useTransition(showImg, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    reverse: showImg,
    delay: 500,
    config: { mass: 1, tension: 280, friction: 120 },
  })

  const { authKey } = useAuth();

  const agreeText = [
    '1. 개인정보 수집 및 이용 목적 : 당첨자 선정',
    '2. 수집하려는 개인정보의 항목 : 이름, 휴대폰 번호',
    '3. 개인정보의 보유 및 이용 기간 : 당첨자 선정 후 3개월간 보관 후 파기',
    '4. 본 개인정보 제공에 동의를 거부할 권리가 있으며, 동의 거부 시 이벤트 참여가 제한됩니다.',
    '5. 제공하신 개인정보는 이벤트 경품 발송 용도 외에는 활용하지 않습니다.',
  ];

  /**
   * @description 비 로그인 유저의 경우 에러에 대한 alert을 출력하지 않는다.
   */
  async function getAttendance() {
    try {
      const res = await apiCall.get(`${LIVE_URL}/api/v1/event/20211015`, { authKey });
      if (res.code === 200) setIdx(res.result.count);

    } catch(err) {
      alert(err?.msg ?? '서버 에러가 발생했습니다.');
      console.log(err?.msg ?? '서버 에러가 발생했습니다.');
    }
  }

  /**
   * @description 출석체크 완료 클릭
   */
  async function submit() {
    if (!agree) return alert('개인정보 수집/이용 에 대한 동의를 체크 해주세요.');

    setSending(true);

    if (isSending) return;

    try {
      const res = await apiCall.post(`${LIVE_URL}/api/v1/event/20211015`, { authKey });
      const errorCode = [501, 502, 503, 504, 507];

      if (errorCode.includes(res.code)) {
        alert(res.msg);

        // 로그인 안되어 있는 경우 로그인 페이지로 이동하는 브릿지
        if (res.code === 501) {
          dabangBridge.ios(call => {
            call.callHandler('ObjC Echo', {
              cmd: 'showLoginAndReload',
            });
          });
      
          dabangBridge.android(call => {
            console.log('android');
            call.showLoginAndReload();
          });
        }
      } else if (res.code === 200) {
        setShowImg(true);
        setTimeout(() => {
          setShowImg(false);
          setIdx(res.result.count > 21 ? 21 : res.result.count);
        }, 1000);
      }

      setSending(false);

    } catch(err) {
      console.log(err);
      setSending(false);
      alert(err?.msg ?? '서버 에러가 발생했습니다.');
    }
  }

  useEffect(() => {
    if (authKey) getAttendance();
  }, [authKey]);

  useEffect(() => {
    transRef.start();
  }, [idx]);

  return (
    <Wrap>
      <BG width={710} height={2400} imgUrl={top} />

      <AgreeWrap>
        <LabelWrap>
          <Label isCheck={agree}>
            <Checkbox type="checkbox" checked={agree} onChange={() => setAgree(prev => !prev)} />
            <p>개인정보 수집/이용 에 대한 동의</p>
            <Arrow />
          </Label>
  
          {agree && (
            <Ul>
              {agreeText.map((text, key) => (
                <li key={key}>{text}</li>
              ))}
            </Ul>
          )}
        </LabelWrap>
      </AgreeWrap>

      <RelativeWrap>
        {transitions((style, i) => (
          <animated.img id="check" style={style} src={CHECK_IMG[i]} alt="" />
        ))}
        <BG width={710} height={1420} imgUrl={mid} />
        <button onClick={submit}></button>
      </RelativeWrap>

      <BG width={710} height={700} imgUrl={bottom} />

      {transitionsStamp(
        (style, item) => item && <animated.img id="stamp" style={style} src={`${stamp}?${new Date().valueOf()}`} alt="" />
      )}
    </Wrap>
  );
}

export default MainComponent;
